import { CSSObject } from '@emotion/react';
import { theme } from 'styles';

const { color } = theme;

const titleRow: CSSObject = {
  alignItems: 'flex-start',
};

const titleWrap: CSSObject = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 6,
  minWidth: 0,
};

const title: CSSObject = {
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  wordBreak: 'break-all',
  fontSize: 15,
  fontWeight: 600,
  lineHeight: 1.4,
  color: color.text,
};

const tagOffset: CSSObject = {
  marginTop: 1,
};

const dateOffset: CSSObject = {
  lineHeight: '21px',
};

const period: CSSObject = {
  display: 'flex',
  gap: 8,
  fontSize: 13,
  color: color.textSub,
  dt: {
    flex: 'none',
    color: color.textMuted,
  },
};

export { titleRow, titleWrap, title, tagOffset, dateOffset, period };
